export default __webpack_public_path__ + "static/media/explore.f57ef438.jpg";